'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var returnAttributes = function returnAttributes(attributes) {
  var newAttributesObject = Object.keys(attributes).reduce(function (previousValue, currentElement) {
    if (attributes[currentElement]) {
      previousValue[currentElement] = attributes[currentElement];
    }

    return previousValue;
  }, {});
  return newAttributesObject;
};

exports.returnAttributes = returnAttributes;